import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    topPinpadIsBusy: false,
    topPosIsBusy: false,
    topTransferIsBusy: false,
    topAccountIsBusy: false,
    initialLoad: true,
    refresh: false,
    startDate: "",
    knnkn: "",
    endDate: "",
    hasEndDate: false,
    topPinpad: {
      data: [],
    },
    topPos: {
      data: [],
    },
    topTransfer: {
      data: [],
    },
    topAccount: {
      data: [],
    },
  },
  mutations: {
    GET_TOP_PINPAD_START: (state) => {
      state.topPinpadIsBusy = true;
    },
    GET_TOP_PINPAD_FAILED: (state, error) => {
      state.topPinpadIsBusy = false;
      state.refresh = false;
      state.error = error;
    },
    GET_TOP_PINPAD_SUCCESS: (state, topPinpad) => {
      state.topPinpadIsBusy = false;
      state.refresh = false;
      state.topPinpad = topPinpad;
      console.log(topPinpad);
    },
    GET_TOP_POS_START: (state) => {
      state.topPosIsBusy = true;
    },
    GET_TOP_POS_FAILED: (state, error) => {
      state.topPosIsBusy = false;
      state.refresh = false;
      state.error = error;
    },
    GET_TOP_POS_SUCCESS: (state, topPos) => {
      state.topPosIsBusy = false;
      state.initialLoad = false;
      state.refresh = false;
      state.topPos = topPos;
      console.log(topPos);
    },
    GET_TOP_TRANSFER_START: (state) => {
      state.topTransferIsBusy = true;
    },
    GET_TOP_TRANSFER_FAILED: (state, error) => {
      state.topTransferIsBusy = false;
      state.refresh = false;
      state.error = error;
    },
    GET_TOP_TRANSFER_SUCCESS: (state, topTransfer) => {
      state.topTransferIsBusy = false;
      state.refresh = false;
      state.topTransfer = topTransfer;
      console.log(topTransfer);
    },
    GET_TOP_ACCOUNT_START: (state) => {
      state.topAccountIsBusy = true;
    },
    GET_TOP_ACCOUNT_FAILED: (state, error) => {
      state.topAccountIsBusy = false;
      state.refresh = false;
      state.error = error;
    },
    GET_TOP_ACCOUNT_SUCCESS: (state, topAccount) => {
      state.topAccountIsBusy = false;
      state.refresh = false;
      state.topAccount = topAccount;
      console.log(topAccount);
    },
    REFRESH: (state) => {
      state.refresh = true;
    },
    DATE_RANGE: (state, startDate, endDate) => {
      state.startDate = startDate;
      state.endDate = endDate;
      state.hasEndDate = true;
    },
  },
  actions: {
    async getTopPinpad({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_TOP_PINPAD_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/top?start=${payload.startDate}&end=${payload.endDate}&type=pinpad&page=${payload.page}`,
          config
        );
        const data = await response.json();
        commit("GET_TOP_PINPAD_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_TOP_PINPAD_FAILED", err);
      }
    },
    async getTopPos({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_TOP_POS_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/top?start=${payload.startDate}&end=${payload.endDate}&type=pos&page=${payload.page}`,
          config
        );
        const data = await response.json();
        commit("GET_TOP_POS_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_TOP_POS_FAILED", err);
      }
    },
    async getTopTransfer({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_TOP_TRANSFER_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/top?start=${payload.startDate}&end=${payload.endDate}&type=transfer&page=${payload.page}`,
          config
        );
        const data = await response.json();
        commit("GET_TOP_TRANSFER_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_TOP_TRANSFER_FAILED", err);
      }
    },
    async getTopAccount({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_TOP_ACCOUNT_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/top?start=${payload.startDate}&end=${payload.endDate}&type=account&page=${payload.page}`,
          config
        );
        const data = await response.json();
        commit("GET_TOP_ACCOUNT_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_TOP_ACCOUNT_FAILED", err);
      }
    },
    async dateRange({ commit }, payload) {
      commit("DATE_RANGE", payload.startDate, payload.endDate);
    },
  },
};
